import { Pipe, PipeTransform } from '@angular/core';
import { forEach } from '@angular/router/src/utils/collection';
import { isNgTemplate } from '@angular/compiler';

@Pipe({
    name: 'targetQuestion'
})
export class TargetQuestionPipe implements PipeTransform {

    transform(list: any[], startResultList: any[]): any[] {

        function filterByTarget(item) {
            //もしかしたらifでlenghtいるかも
            item.targetShow = true;
            let showFlg_a = true;
            let showFlg_c = false;
            let showFlg_o = false;

            /*単一回答式の場合*/
            if (item.target_list.length > 0) {
                let showList_a = [];
                for (let i in item.target_list) {
                    //ループに入ったので初期値としてflaseを入れておく
                    showList_a[i] = false;

                    let targetResult = startResultList.filter(
                        result => 
                        result.q_id == item.target_list[i].base_question_id
                    );

                    if(!targetResult) continue;
                    
                    if (targetResult[0]["a_id"] != null && targetResult[0]["a_id"] == item.target_list[i].target_id) {
                        showList_a[i] = true;
                    }
                }
                
                for (let i in showList_a) {
                    //showList内に一つでもfalseがあれば表示させない
                    showFlg_a = showFlg_a && showList_a[i];
                }
            }else{
                showFlg_a = true;
            }

            /*特定化学物質の場合*/
            if (item.target_chemical_substance_list.length > 0) {
                let showList_c = [];
                for (let i in item.target_chemical_substance_list) {
                    //ループに入ったので初期値としてflaseを入れておく
                    showList_c[i] = false;
                    
                    let tempres = startResultList.filter(
                        res => 
                        res.q_type == 6
                    );
                    
                    if(!tempres) continue;

                    //result.a_sp_id_listの中に、targetのtarget,idがあるかないか
                    let targetResult = tempres[0].a_sp_id_list.filter(function( val ) {
                        return val == item.target_chemical_substance_list[i].target_id;
                    });

                    //一つでもtrueがあれば表示させる
                    if(targetResult.length>0) {
                        showFlg_c = true;
                        break;
                    }
                }
            }else{
                showFlg_c = true;
            }

            /*有機溶剤の場合*/
            if (item.target_organic_solvent_list.length > 0) {
                let showList_o = [];
                for (let i in item.target_organic_solvent_list) {
                    //ループに入ったので初期値としてflaseを入れておく
                    showList_o[i] = false;

                    let tempres = startResultList.filter(
                        res => 
                        res.q_type == 7
                    );
                    
                    if(!tempres) continue;

                    //result.a_sp_id_listの中に、targetのtarget,idがあるかないか
                    let targetResult = tempres[0].a_sp_id_list.filter(function( val ) {
                        return val == item.target_organic_solvent_list[i].target_id;
                    });

                    //一つでもtrueがあれば表示させる
                    if(targetResult.length>0) {
                        showFlg_o = true;
                        break;
                    }
                }
            }else{
                showFlg_o = true;
            }               

            item.targetShow = showFlg_a && showFlg_c && showFlg_o;

            //その質問にtargetListがないので、全員に対して表示する
            return item.targetShow;
        }


        return list.filter(filterByTarget);
    }

}


// WEBPACK FOOTER //
// ./src/app/pipes/target-question.pipe.ts